import { INutrient, ICartBox, IChild } from '@interfaces';
import { NutrientsList } from '@components/common/presentational/nutrients/nutrients-list';
import { calculateAgeInMonths } from '@v2/components/pages/quiz/utils';
import { milestoneIcons } from '@components/common/recommendations/developmental/focus';

import styles from './stage.footer.styles';
import { WPImage } from '@v2/utils/image';

export default function BoxStageFooter({ box, sBox}: { box: ICartBox, sBox?: IChild }) {
    box = ((sBox && sBox.isChild)
            ?
            {
                child: {
                    birthdate: sBox.birthday ? sBox.birthday : null
                },
                stage: sBox.stage
            }
            : box) as ICartBox;

    const focus = (box && box.stage && box.stage.developmental && box.stage.developmental.focus)
                    ? box.stage.developmental.focus
                    : null;

    return (
        <>
            {box.stage &&
                <div className={`${styles} personalized-footer`}>
                    <div className="personalized-age-info">
                        <span className="personalized-header">age</span>
                        <span className="personalized-body">
                            <span className="months-count">
                                {box.child.birthdate
                                        ? calculateAgeInMonths(box.child.birthdate)
                                        : null
                                }
                            </span>
                            <span className="title">Months</span>
                        </span>
                    </div>
                    { /* @ts-ignore */}
                    {(focus && milestoneIcons[focus.toUpperCase()]) &&
                        <div className="personalized-developmental-info">
                            <span className="personalized-header">DEVELOPMENTAL FOCUS</span>
                            <span className="personalized-body">
                                <span className="developmental-focus">
                                    { /* @ts-ignore */}
                                    <img src={milestoneIcons[focus.toUpperCase()]} alt={'Milestone Visual Icon'} />
                                </span>
                                <span className="title">{focus.charAt(0).toUpperCase() + focus.slice(1).toLowerCase()}</span>
                            </span>
                        </div>
                    }
                    {box.stage.developmental && box.stage.developmental.brainImage &&
                    <div className="personalized-region-info">
                        <span className="personalized-header">ACTIVE BRAIN REGION</span>
                        <span className="personalized-body">
                            <span className="brain-region">
                                {box.stage.developmental &&
                                    <WPImage src={box.stage.developmental.brainImage} alt={box.stage.developmental.brainText} />
                                }
                            </span>
                            <span className="title">
                                {box.stage.developmental &&
                                    box.stage.developmental.brainText
                                }
                            </span>
                        </span>
                    </div>
                    }
                    <div className="personalized-nutrients-info">
                        <span className="personalized-header">Key nutrients</span>
                        <span className="personalized-body">
                            {
                                box.stage && box.stage.nutrients &&

                                <NutrientsList nutrients={box.stage.nutrients as INutrient[]} onlyKey={false} />
                            }
                        </span>
                    </div>
                </div>
            }
        </>
    );
}